/**
 * Replaces certain characters with space. This is useful for sanitizing text
 * that is copied from sources that use these characters for formatting, which
 * may lead to unexpected behavior in the code editor.
 * The characters replaced are:
 *  - U+2000 - U+2009 En/Em Quad and Space
 *  - U+200A Hair space
 *  - U+200B Zero Width Space
 *  - U+202F Narrow No-Break Space
 *  - U+205F Medium Mathematical Space
 *  - U+3000 Ideographic Space
 */
export function sanitizeText(value: string): string {
  return value.replace(/[\u2000-\u2009\u200A\u200b\u202f\u205f\u3000]/g, ' ');
}
